import React, {Component} from 'react';

import user_model from 'models/user_model'
import Files from 'xAppLib/Files/Files';

const DEBUG = true

export default class AddResult extends Component {

	constructor (props) {
		super(props)

		user_model.limit_access('admin');

		this.state = {
			upl_files: props.value || [],
			loading:false,
			
		}
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	async attach_files (files) {
		
		// TODO ?
	}

	// 		--------------------------------		--------------------------------		---------

	onAddFile = async (f) => {
		DEBUG && console.log("onAddFile()");
		const files = this.state.upl_files.concat(f)
		DEBUG && console.log({files});
		this.setState({upl_files:files})
		//await this.attach_files(files)
		this.setState({refresh:new Date().getTime(), new_result:true})
		this.props.onChange && this.props.onChange({target:{name:this.props.fl.name,value:files}})
	}
	
	onInputChange = (e, { name, value }) => this.setState({ [name]: value })

	
	// 		--------------------------------		--------------------------------		---------

	render() {

		const { upl_files} = this.state
		const { level='misc', addPIT = false, accept = null, children, allowDirectLink } = this.props
		
		return <React.Fragment>
					<Files
							target={this.props.target}
							inline
							level={level}
							data = {upl_files}
							onAddFile={this.onAddFile}
							addNotes={false}
							onChange = { ps => this.setState({upl_files:ps}) }
							addPIT={addPIT}
							accept={accept}
						 >
						{children}
					 </Files>
				
			</React.Fragment>

		
	}

}
